import { useSelector } from 'react-redux';

import PrivateRoute from 'containers/PrivateRoute';
import { canManageMarketingCampaigns } from '../utils/marketingCampaignPermissions';

import SetupCheckerWrapper from './SetupCheckerWrapper';

export const MarketingManagementGuard = ({ children }) => {
    const isAllowed = useSelector(canManageMarketingCampaigns);

    return (
        <PrivateRoute isAllowed={isAllowed} redirectTo="/">
            {children}
        </PrivateRoute>
    );
};

const MarketingManagementRoute = ({ children }) => (
    <MarketingManagementGuard>
        <SetupCheckerWrapper>{children}</SetupCheckerWrapper>
    </MarketingManagementGuard>
);

export default MarketingManagementRoute;
